module.exports = {
    "title": "Maintenance",
    "entityName": "maintenance",
    "pagination": {
        "rowsPerPage": 10,
        "page": 1,
        "sortBy": "id",
        "descending": true
    },
    "fields": [
        {
            "value": "service",
            "text": "Service",
            "type": "list",
            "table": {
                "sortable": true,
                "filter": true
            },
            list: ['SafetyDB', 'EMN Logistic', 'eCDS', 'eTMF', 'REDCap - EMN Trial Office', 'REDCap - EMN Italy', 'REDCap - EMN International'],
        },

        {
            
            "value": "protocol_id",
            "text": "Protocol",
            title: "name",
            "type": "autocomplete",
            filter: (item, search) => { 
                
                let searchObj = { 'protocol.provider': 'REDCap', 'protocol.status' : '!=Draft'}

                if(search) {
                    searchObj['protocol.name'] = `%${search}%`
                }

                if(item.service == 'REDCap - EMN Trial Office') {
                    searchObj['protocol.sponsor_id'] = 1
                }

                if(item.service == 'REDCap - EMN Italy') {
                    searchObj['protocol.sponsor_id'] = 2
                }

                if(item.service == 'REDCap - EMN International') {
                    searchObj['protocol.sponsor_id'] = 4
                }

                return searchObj
            },
            render: item => `${item.protocol.name}`,
            deps:['service'],
            visible: (search) => {
                return ['REDCap - EMN Trial Office', 'REDCap - EMN Italy', 'REDCap - EMN International'].includes(search.service)
            }
        },

        {
            full:true,
            "value": "title",
            "text": "Title",
            "type": "text",
            "table": {
                "sortable": true,
                "filter": true
            },
            "validators": [
                "required",
            ]
        },

        {
            full:true,
            "value": "message",
            "text": "Message",
            "type": "component",
            //"name": "app-rich-text-field",
            "name": "app-tinymce-editor",
            // "table": {
            //     "sortable": true,
            //     "filter": true
            // },
            "validators": [
                // "required",
            ]
        },

        {
            "value": "validFrom",
            "text": "Valid From",
            
            //ISSUE 207
            //"type": "datetime",
            "type" : "date",
            filtertofrom: true,
            //ISSUE 207

            "table": {
                "sortable": true,
                "filter": true
            },
            // "validators": [
            //     "required",
            // ]
        },

        {
            "value": "validUntil",
            "text": "Valid Until",
            
            //ISSUE 207
            //"type": "datetime",
            "type" : "date",
            filtertofrom: true,
            //ISSUE 207

            "table": {
                "sortable": true,
                "filter": true
            },
            // "validators": [
            //     "required",
            // ]
        },

        {
            "value": "allowLogin",
            "text": "Login Allowed",
            "type": "check",
            "table": {
                "sortable": true,
                "filter": true
            },
            "validators": [
                // "required",
            ]
        },


        {
            "value": "status",
            "text": "Status",
            "type": "list",
            "list": ['Enabled', 'Disabled'],
            "table": {
                "sortable": true,
                "filter": true
            },
            "validators": [
                // "required",
            ]
        },
       

    ],
    "actions": [
         "upsert", "remove", "audit_trail"
    ]
}